import React from 'react'
import About from '../Home/About'
import Vission from '../Home/Vission'

const AboutPage = () => {
  return (
    <>
        <About/>
        <Vission/>
    </>
  )
}

export default AboutPage